var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error__code"},[_vm._v(_vm._s(_vm.$route.query.error_code))]),_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.$route.query.error_title)))]),_c('p',{staticClass:"error__message"},[_vm._v("\n      "+_vm._s(_vm.$t(_vm.$route.query.error_message))+"\n   ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }